import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import React from 'react';
import ContentLoader from 'react-content-loader';
import useLoaderEditingAttrs from '../internal/useLoaderEditingAttrs';
import ClientOnly from '@/components/ClientOnly';
import styles from './styles.module.scss'; // interface Props {}

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const VisualReceiptListLoading = _ref => {
  let {
    editing = false
  } = _ref;
  const editingAttrs = useLoaderEditingAttrs(editing);
  return /*#__PURE__*/_jsx(ClientOnly, {
    children: /*#__PURE__*/_jsxs("ul", {
      className: styles.list,
      children: [[95, 120, 75, 100].map((width, i) => /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread({
        className: styles.item
      }, editingAttrs), {}, {
        children: [/*#__PURE__*/_jsx("span", {
          className: clsx(styles.item__name, styles.label),
          children: /*#__PURE__*/_jsx(TextLoader, {
            width: width
          })
        }), /*#__PURE__*/_jsx("span", {
          className: styles.item__underline
        }), /*#__PURE__*/_jsx("span", {
          className: clsx(styles.item__value, styles.label),
          children: /*#__PURE__*/_jsx(TextLoader, {})
        })]
      }), `visual-receipt-loader-${width}${i}`)), /*#__PURE__*/_jsxs("li", _objectSpread(_objectSpread({
        className: clsx(styles.item, styles['item--last'])
      }, editingAttrs), {}, {
        children: [/*#__PURE__*/_jsx("span", {
          className: clsx(styles.item__name, styles.label, styles['label--lastLabel']),
          children: /*#__PURE__*/_jsx(LastLabelLoader, {})
        }), /*#__PURE__*/_jsx("span", {
          className: clsx(styles.item__value, styles.label, styles['label--lastValue']),
          children: /*#__PURE__*/_jsx(LastValueLoader, {})
        })]
      }))]
    })
  });
};

const TextLoader = _ref2 => {
  let {
    width = 60
  } = _ref2;
  return /*#__PURE__*/_jsx(ContentLoader, {
    height: 20,
    style: {
      width: `${width}px`
    },
    viewBox: `0 0 ${width} 20`,
    children: /*#__PURE__*/_jsx("rect", {
      x: "0",
      y: "0",
      width: width,
      height: "17"
    })
  });
};

const LastLabelLoader = () => /*#__PURE__*/_jsx(ContentLoader, {
  height: 25,
  style: {
    width: '110px'
  },
  viewBox: "0 0 110 25",
  children: /*#__PURE__*/_jsx("rect", {
    x: "0",
    y: "0",
    width: "110",
    height: "22"
  })
});

const LastValueLoader = () => /*#__PURE__*/_jsx(ContentLoader, {
  height: 50,
  style: {
    width: '105px'
  },
  viewBox: "0 0 105 50",
  children: /*#__PURE__*/_jsx("rect", {
    x: "0",
    y: "1",
    width: "105",
    height: "45"
  })
});

export default VisualReceiptListLoading;